<template>
<v-container class="pa-0 mt-4">
    <v-card class="elevation-0 mb-0 pb-0">
        <!--v-card-title class="px-2 py-1 align-baseline">
            <div class="d-flex align-center justify-between full-width" v-on:click="$emit('header_click')">
                <div class="d-flex font-weight-bold text-uppercase flex-grow-1 text-truncate">
                    <slot name="title">{{ title }}</slot>
                </div><div class="d-flex justify-end">
                    <slot name="action"></slot>
                </div>
            </div>
        </v-card-title-->
        <div class="px-2 py-1 align-baseline" v-if="show_title">
        <div class="elevation-1 suggestion white--text rounded-tl rounded-r ml-n2 mb-n1 mt-n1 pa-2 d-flex align-center justify-between full-width">
            <div class="d-flex text-h6 text-uppercase font-italic full-width text-truncate">
                <slot name="title">{{ title }}</slot>
            </div><div class="d-flex justify-end">
                <slot name="action"></slot>
            </div>
        </div> 
        </div>
        <v-card-text class="elevation-2 mx-0 px-0 py-0 mb-2">
            <slot></slot>
        </v-card-text>
    </v-card>
</v-container>
            
</template>

<script>
export default {
    props: {
        'title': {
            type: String,
            required: false,
            default: ''
        }, 
        'show_title': {
            type: Boolean,
            required: false,
            default: true
        }
    },
    beforeDestroy() {
    },    
}
</script>

<style>
.basic_card .v-expansion-panel__header {
    padding: 0px;
    margin:0px;
    min-height: 0px !important;
}

</style>
